<template>
  <div class="MyInvestment">
    <section class="InvestmentHeader">
      <header>
        <small>{{$t('TP.TotalPrinciple')}}</small>
        <h3>{{totalInvestment}} {{currentNetwork.symbol }}</h3>

        <section class="quantity">
          <div>
            <p>{{$t('TP.PoolAssets', { symbol: currentNetwork.symbol })}}</p>
            <h5>{{totalRex}}</h5>
          </div>

          <div>
            <p>{{$t('TP.CPUNETStaked', { symbol: currentNetwork.symbol })}}</p>
            <h5>{{totalResource}}</h5>
          </div>
        </section>
      </header>

      <TPoolsText :text="$t('TP.InvestmentDetails', { symbol: currentNetwork.symbol})"/>
    </section>

    <main class="InvestmentWrap">
      <van-pull-refresh v-model="isLoading"
                        :pulling-text="$t('TP.pullDown')"
                        :loosing-text="$t('TP.release')"
                        :loading-text="$t('TP.loading')"
                        @refresh="onRefresh">
        <van-list v-model="isNextLoading"
                  :finished="isFinished"
                  :loading-text="$t('TP.loading')"
                  @load="onLoad">
          <div class="investment-item" v-for="(item, index) in selfPoolsRecordList" :key="index">
            <div class="info color-666">
              <h5 class="color-3A3B3D">{{item.from}}</h5>
              <p>{{item.date}}</p>
            </div>
            <div class="quantity">
              <h5 class="color-3A3B3D">{{item.amount}}</h5>
              <p v-if="item.status === 1" class="color-4BC136">{{$t('TP.NewInvestment')}}</p>
              <p v-if="item.status === 0" class="color-C9442C">{{$t('TP.WithdrawInvestment')}}</p>
            </div>
          </div>
        </van-list>
      </van-pull-refresh>
    </main>

    <footer class="Footer">
      <button @click="investmentBack">{{$t('TP.WithdrawInvestmentBack')}}</button>
    </footer>

    <section class="investment-back-wrap" v-show="isShow">
            <div class="investment-back-main">
              <h4>{{$t('TP.WithdrawInvestmentBack')}}</h4>
              <p>{{$t('TP.TotalPoolAssets')}}：{{totalInvestment}} {{currentNetwork.symbol}}</p>
              <p>{{$t('TP.WithDrawable')}}: {{canSellEOS}} {{currentNetwork.symbol}}</p>
              <p style="color: #2980FE;margin-bottom: 20px;display: flex;align-items: center" @click="goResource">
                {{$t('TP.CPUNETStakedReclaim')}}
                <i class="TP-Font tp-font-arrow" style="font-size: 18px;margin-top: 1px;"></i>
              </p>

              <TPoolsInput @quantity="data => quantity = data"
                           :amount="quantity"
                           :all-balance="canSellEOS"
                           :placeholder="$t('TP.InputAmount')"
                           all-color="#000"/>

              <div style="margin-top: 32px">
                <button @click="sellRex">{{$t('TP.Confirm')}}</button>
              </div>

              <i class="investment-back-close" @click="investmentBackclose"></i>
            </div>
    </section>

  </div>
</template>

<script>
import { mapGetters } from 'vuex'
export default {
  name: 'MyInvestment',
  props: ['blockchainId'],
  data () {
    return {
      isLoading: false,
      isShow: false,
      quantity: 0,
      isNextLoading: false,
      isFinished: false
    }
  },

  computed: {
    ...mapGetters([
      'totalInvestment',
      'totalRex',
      'totalResource',
      'TPAccountInfo',
      'selfPoolsRecordList',
      'rexPrice',
      'totalRexBalance',
      'rexUnStake',
      'currentNetwork',
      'eosService'
    ]),
    canSellEOS () {
      return (this.rexPrice * this.rexUnStake).toFixed(4)
    }
  },

  methods: {
    async onRefresh () {
      this.$store.commit('SELF_POOLS_RECORD_LIST', { type: 'init', data: [] })
      this.$store.dispatch('getSelfPoolRecordList', { type: 'next' }).then(res => {
        setTimeout(() => {
          this.isFinished = false
          this.isLoading = false
        }, 500)
      }).catch(() => {
        setTimeout(() => {
          this.isFinished = false
          this.isLoading = false
        }, 500)
      })
    },

    onLoad () {
      this.$store.dispatch('getSelfPoolRecordList', { type: 'next' }).then(res => {
        setTimeout(() => {
          this.isNextLoading = false
        }, 500)
        if (res.data === null) {
          setTimeout(() => {
            this.isFinished = true
          }, 500)
        }
      }).catch(() => {
        setTimeout(() => {
          this.isLoading = false
        }, 500)
      })
    },

    investmentBack () {
      this.isShow = true
    },

    investmentBackclose () {
      this.isShow = false
      this.quantity = null
    },

    goResource () {
      window.location.href = 'tp://localResource'
    },

    async sellRex () {
      if (parseFloat(this.quantity) > 0 && parseFloat(this.quantity) <= parseFloat(this.canSellEOS)) {
        const quantity = parseFloat((Math.ceil(this.quantity / this.rexPrice * 10000) / 10000).toFixed(4))
        const quantityRex = quantity > this.totalRexBalance ? this.totalRexBalance : quantity

        this.$store.dispatch('sellRex', {
          quantityRex,
          quantityEos: parseFloat(this.quantity).toFixed(4)
        }).then(res => {
          this.$store.dispatch('initData', this.blockchainId)
          this.$toast(this.$t('TP.withdrawSuccess'))
          this.isShow = false
          this.quantity = null
        })
          .catch(error => {
            this.$store.dispatch('isAlertError', error)
            // if (error.message.indexOf('User rejected') === -1 && error.message.indexOf('Cannot read') === -1) alert(JSON.stringify(error))
          })
      }
    }
  },

  created () {
    this.$store.dispatch('initData', this.blockchainId)
  },

  mounted () {
    setTimeout(() => {
      const InvestmentHeader = this.$el.querySelector('.InvestmentHeader')
      const InvestmentWrap = this.$el.querySelector('.InvestmentWrap')
      const Footer = this.$el.querySelector('.Footer')
      InvestmentWrap.style.height = (window.innerHeight - InvestmentHeader.scrollHeight - Footer.scrollHeight) + 'px'
    }, 200)

    if (this.eosService) this.onRefresh()
  },

  watch: {
    eosService () {
      this.onRefresh()
    }

  }
}
</script>

<style lang="scss" scoped>
  .MyInvestment {
    .InvestmentHeader {
      margin-bottom: 10px;
      header {
        padding-top: constant(safe-area-inset-top)!important;
        padding-top: env(safe-area-inset-top)!important;
        padding-bottom: 30px;
        text-align: center;
        background:linear-gradient(90deg,rgba(255,117,12,1) 0%,rgba(255,181,22,1) 100%);

        h3 {
          margin: 0;
          font-size: 26px;
          color: #fff;
        }

        small {
          display: inline-block;
          font-size: 14px;
          padding: 30px 0 12px;
          color: #fff;
        }

        .quantity {
          display: flex;
          margin-top: 16px;
          div {
            flex: 1;
            &:first-child {
              border-right: 1px solid #fff;
            }
            p {
              font-size: 13px;
              color: #fff;
              margin: 0;
            }

            h5 {
              margin: 5px 0 0;
              font-size: 14px;
              color: #fff;
            }
          }
        }
      }
    }

    .InvestmentWrap {
      overflow-y: auto;
      .investment-item {
        display: flex;
        padding: 16px 16px 16px 0;
        margin-left: 16px;
        align-items: center;
        border-bottom: 1px solid #E6E8EA;

        h5, p {
          margin: 0;
        }

        h5 {
          font-size: 14px;
          margin-bottom: 4px;
          font-weight: 500;
        }

        p {
          font-size: 13px;
        }

        .info {
          flex: 1;
        }

        .quantity {
          flex: 1;
          text-align: right;

        }
      }
    }

    footer{
      position: fixed;
      bottom: 0;
      left: 0;
      right: 0;
      padding-bottom: constant(safe-area-inset-bottom);
      padding-bottom: env(safe-area-inset-bottom);
      button {
        width: 100%;
        outline: none;
        border: 0;
        color: #fff;
        background: #FF600C;
        height: 49px;
        line-height: 49px;
        font-size: 16px;
      }
    }

  }

  .investment-back-wrap {
    position: fixed;
    background: rgba(0,0,0, 0.4);
    /*width: 100vw;*/
    /*height: 100vh;*/
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    z-index: 99999;
    .investment-back-main {
      display: inline-block;
      width: 70%;
      padding: 20px;
      background: #fff;
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translateX(-50%) translateY(-50%);
      border-radius: 4px;
      h4 {
        text-align: center;
        color: #3A3B3D;
        font-weight: 500;
        font-size: 16px;
        margin: 0 0 16px;
      }

      p {
        color: #9EA0A5;
        font-size: 14px;
        margin: 4px 0;
      }

      button {
        width: 100%;
        border: 0;
        outline: none;
        background: #FF600C;
        color: #fff;
        font-size: 16px;
        font-weight: 500;
        padding: 11px 0;
        border-radius: 4px;
      }

      .investment-back-close {
        display: inline-block;
        width: 30px;
        height: 30px;
        background: url(../../assets/images/close.png) no-repeat 100% / contain;
        position: absolute;
        left: 50%;
        bottom: -40px;
        transform: translateX(-50%);
      }
    }
  }

</style>
